import { getCardTypeFromEntity } from "@/features/cards/shared/card-routing/card-types";
import { openZustandCard } from "@/features/cards/shared/legacy/open-zustand-card";
import FocusContext from "../map-management/focus-context";
import MapEntityBase from "../map-management/map-entities/map-entity-base";

export function getDeviceMapEntityById(deviceId: string): MapEntityBase | undefined {
    return FocusContext.MapEntitesByModelID[deviceId];
}

export async function openDeviceCardById(deviceId: string, options?: { initialPanelKey?: string }): Promise<boolean> {
    const mapEntity = getDeviceMapEntityById(deviceId);
    if (!mapEntity) {
        console.warn(`Could not open device card for id ${deviceId}`);
        return false;
    }

    openZustandCard({
        entity: mapEntity,
        cardType: getCardTypeFromEntity(mapEntity),
        initialPanelKey: options?.initialPanelKey,
    });

    return true;
}
